
import { useState, useEffect } from 'react';
import ConfettiEffect from '@/components/ConfettiEffect';
import HeaderV3 from '@/components/landing-v3/HeaderV3';
import HeroSectionV3 from '@/components/landing-v3/HeroSectionV3';
import WhatIsPACTSection from '@/components/landing-v3/WhatIsPACTSection';
import ProblemSection from '@/components/landing-v3/ProblemSection';
import FeaturesSectionV3 from '@/components/landing-v3/FeaturesSectionV3';
import HowItWorksSection from '@/components/landing-v3/HowItWorksSection';
import BeforeAfterSection from '@/components/landing-v3/BeforeAfterSection';
import FounderStorySection from '@/components/landing-v3/FounderStorySection';
import EmailSignupSectionV3 from '@/components/landing-v3/EmailSignupSectionV3';

const LandingPageV3 = () => {
  const [showConfetti, setShowConfetti] = useState(false);

  // SEO optimization
  useEffect(() => {
    document.title = "Show Up! - PACT-Based Commitments That Come Before Habits | Show Up Every Day";
    
    // Meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Your daily buddy for PACT-based commitments. Show up every day with gentle encouragement, AI-powered suggestions, and insights that help you understand yourself better.');
    }
  }, []);

  const handleConfettiTrigger = () => {
    setShowConfetti(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 via-purple-700 to-purple-800 relative overflow-hidden">
      {/* Enhanced Background Elements with warmer colors */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-10 left-1/4 w-48 h-48 bg-yellow-400/20 rounded-full blur-3xl animate-pulse-gentle"></div>
        <div className="absolute top-1/3 right-10 w-32 h-32 bg-yellow-300/25 rounded-full blur-2xl animate-pulse-gentle delay-1000"></div>
        <div className="absolute bottom-1/4 left-10 w-40 h-40 bg-white/15 rounded-full blur-3xl animate-pulse-gentle delay-500"></div>
        <div className="absolute top-2/3 right-1/3 w-24 h-24 bg-yellow-500/20 rounded-full blur-xl animate-pulse-gentle delay-700"></div>
        <div className="absolute bottom-10 right-20 w-36 h-36 bg-purple-300/20 rounded-full blur-2xl animate-pulse-gentle delay-300"></div>
      </div>

      <div className="relative z-10">
        <HeaderV3 />
        <HeroSectionV3 onPhoneClick={handleConfettiTrigger} />
        <WhatIsPACTSection />
        <ProblemSection />
        <FeaturesSectionV3 />
        <HowItWorksSection />
        <BeforeAfterSection />
        <FounderStorySection />
        <EmailSignupSectionV3 />
        
        {/* Footer with navigation to app */}
        <footer className="container max-w-6xl mx-auto px-4 py-16 text-center">
          <div className="border-t border-white/20 pt-8">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
              <div className="text-white/80">
                <p className="font-medium">© 2024 Show Up! All rights reserved.</p>
              </div>
              <div className="flex gap-6">
                <a 
                  href="/" 
                  className="text-white/80 hover:text-white transition-colors font-medium"
                >
                  Try App
                </a>
                <a 
                  href="/app" 
                  className="text-white/80 hover:text-white transition-colors font-medium"
                >
                  Dashboard
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>

      <ConfettiEffect
        trigger={showConfetti}
        type="complete"
        onComplete={() => setShowConfetti(false)}
      />
    </div>
  );
};

export default LandingPageV3;
